import React from "react";
import { Box, Paper, Typography } from "@mui/material";

/**
 * Application settings shell — route wired for menuConfig SETTINGS_MANAGE.
 */
const Settings = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
      Settings
    </Typography>
    <Paper sx={{ p: 3 }}>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Application preferences and configuration are managed through the admin modules:
      </Typography>
      <Typography component="ul" sx={{ pl: 3, m: 0 }}>
        <li>User Management — users, roles, geography</li>
        <li>Privilege Management — menu and feature access</li>
        <li>Email Configuration — notification templates</li>
        <li>Approval &amp; SLA Configuration — workflow and TAT</li>
      </Typography>
    </Paper>
  </Box>
);

export default Settings;
